class BanzrcDtMotion extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('[data-dt-motion]');
    if (!video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) video.play().catch(() => {});
      else video.pause();
    }, { rootMargin: '20% 0px', threshold: 0.2 });
    this.observer.observe(video);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('banzrc-dt-motion')) {
  customElements.define('banzrc-dt-motion', BanzrcDtMotion);
}
